export const PATHS = {
  HOME: '/',
  REQUESTS: '/requests',
  CREATE_REQUEST: '/requests/create',
  ARTICLES: '/articles',
  ARTICLE: '/articles/:articleId',
  DOCUMENTS: '/documents',
  EVENTS: '/events',
  CHANGE_PASSWORD: '/reset-password',
  ACCIDENTS: (id?: number) => (id ? `/accidents/${id}` : '/accidents'),
  CAR_RENTAL: (id?: number) => (id ? `/car-rental/${id}` : '/car-rental'),
  MESSAGES: '/messages',
  STATISTICS: '/statistics',
  STATEMENTS: '/statements',
  REWARDS: 'rewards',
  INCOMES: 'incomes',
  CONTACTS: '/contacts',
  COMMISSIONS: '/commissions',
  NEW_ACCIDENT: (id?: string) => (id ? `/accidents/new/${id}` : '/accidents/new'),
  ACCIDENT_CONFIRM: (id: string, accidentTaken?: boolean) => `/accidents/confirm/${id}?accidentTaken=${accidentTaken}`,
  TIPPERS: (id?: number) => (id ? `/tippers/${id}` : '/tippers'),
  SERVICES: (id?: number) => (id ? `/services/${id}` : '/services'),
  CASH_RECEIPTS: 'cash-receipts',
  UNPAID_COMMISSIONS: 'unpaid-commissions',
  EXPENSE_DOCUMENTS: 'expense-documents'
};
